/**
 * String utilities
 */

/**
 * Convert kebab-case to camelCase
 * e.g. "my-projects" → "myProjects"
 */
export const toCamelCase = (str) => {
  return str.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
};
